// @/api/model/clientCompany.js

import config from "@/config";
import http from "@/utils/request";

export default {
	page: {
		url: `${config.MAIN_URL}/market/company/clientCompanyList`,
		name: "分页查询客户单位列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getPrincipalList: {
		url: `${config.MAIN_URL}/market/company/getPrincipalList`,
		name: "负责人下拉列表",
		get: async function () {
			return await http.get(this.url);
		},
	},
	getParentCompanyList: {
		url: `${config.MAIN_URL}/market/company/getParentCompanyList`,
		name: "父级单位下拉列表",
		get: async function () {
			return await http.get(this.url);
		},
	},
	addClientCompany: {
		url: `${config.MAIN_URL}/market/company/addClientCompany`,
		name: '新增客户单位',
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},
	updateClientCompany: {
		url: `${config.MAIN_URL}/market/company/updateClientCompany`,
		name: "编辑客户单位",
		put: async function (data) {
			return await http.put(this.url, data);
		},
	},
	deleteClientCompany: {
		url: `${config.MAIN_URL}/market/company/deleteClientCompany`,
		name: "删除客户单位",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},

};
